"use client"

import { useEffect, useState } from "react"
import Link from "next/link"

import { useRouter } from "next/navigation"
import { FaInstagram, FaYoutube, FaXTwitter, FaReddit } from "react-icons/fa6"

import SelfContainedModal from "@/components/modal"
import MarkdownRenderer from "@/components/markdownRenderer"

export default function Footer({ content }: { content: string }) {
    const [isOpen, setIsOpen] = useState(false);
    const router = useRouter()

    useEffect(() => {
        const checkHash = () => {
            setIsOpen(window.location.hash === "#PrivacyPolicy");
        };
        checkHash();
        window.addEventListener("hashchange", checkHash);
        return () => {
            window.removeEventListener("hashchange", checkHash);
        }
    }, []);

    return (
        <footer className="bg-primary-1000 text-white border-t border-primary-900">
            <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
                <div>
                    <h2 className="text-xl font-semibold mb-4">Next Generation Gamers</h2>
                    <p className="text-sm text-gray-400 leading-relaxed">Canadian VTuber company aiming to bring gaming entertainment to the next level!</p>
                    <br />
                    <p className="text-sm text-gray-400 leading-relaxed">Made with ❤️ by the team at NextGG</p>
                </div>

                <div>
                    <h3 className="text-lg font-medium mb-4">Quick Links</h3>
                    <ul className="space-y-2 text-sm text-gray-400">
                        <li>
                            <button
                                className="hover:text-primary-100 transition cursor-pointer"
                                onClick={() => {
                                    window.scrollTo({ top: 0, behavior: "smooth" })
                                    router.replace("")
                                }}
                            >
                                Back to top
                            </button>
                        </li>
                        <li><Link href="#talent" className="hover:text-primary-100 transition">Talent</Link></li>
                        <li><Link href="#audition" className="hover:text-primary-100 transition">Audition</Link></li>
                        <li><Link href="#team" className="hover:text-primary-100 transition">Our Team</Link></li>
                        <li><Link href="#contact" className="hover:text-primary-100 transition">Contact</Link></li>
                    </ul>
                </div>

                <div>
                    <h3 className="text-lg font-medium mb-4">Resources</h3>
                    <ul className="space-y-2 text-sm text-gray-400">
                        <li>
                            <SelfContainedModal
                                classname="flex flex-wrap bg-primary-1000"
                                trigger={
                                    <button
                                        type="button"
                                        className="hover:text-primary-100 transition cursor-pointer"
                                    >
                                        Privacy Policy
                                    </button>
                                }
                                open={isOpen}
                                onOpenChange={setIsOpen}
                            >
                                <div className="text-white">
                                    <MarkdownRenderer content={content} />
                                </div>
                            </SelfContainedModal>
                        </li>
                    </ul>
                </div>

                <div>
                    <h3 className="text-lg font-medium mb-4">Follow Us</h3>
                    <div className="flex space-x-4 text-3xl text-gray-400">
                        <Link href="https://x.com/NextGG_Official" target="_blank" className="hover:text-primary-100 transition" aria-label="Twitter">
                            <FaXTwitter />
                        </Link>
                        <Link href="https://www.reddit.com/user/Next_Gen_Gamers/" target="_blank" className="hover:text-primary-100 transition" aria-label="Reddit">
                            <FaReddit />
                        </Link>
                        <Link href="https://www.youtube.com/@NextGGOfficial" target="_blank" className="hover:text-primary-100 transition" aria-label="Youtube">
                            <FaYoutube />
                        </Link>
                        <Link href="https://www.instagram.com/nextggofficial/" target="_blank" className="hover:text-primary-100 transition" aria-label="Instagram">
                            <FaInstagram />
                        </Link>
                    </div>
                </div>
            </div>

            <div className="max-w-7xl mx-auto px-6 py-6 text-center text-sm text-gray-400">
                All rights reserved. Next Generation Gamers Ltd. ©2026
            </div>
        </footer>
    )
}
